import React from 'react';
import PayLetterPayment from './PayLetterPayment';
import { PayLetterPaymentProps } from './PayLetterPayment.types';

/**
 * 에디터용 PayLetter 결제 컴포넌트 래퍼
 * 에디터에서는 실제 결제 기능을 비활성화하고 미리보기만 제공
 */
const PayLetterPaymentEditor: React.FC<PayLetterPaymentProps> = (props) => {
  // 에디터에서는 결제 버튼을 비활성화하고 미리보기 상태로 표시
  const editorProps = {
    ...props,
    isEditor: true,
    // 에디터에서는 실제 콜백 함수를 실행하지 않음
    onSuccess: undefined,
    onError: undefined,
    onCancel: undefined
  };
  
  return <PayLetterPayment {...editorProps} />;
};

export default PayLetterPaymentEditor; 